module.exports = __webpack_public_path__ + "img/mob4.ee2daef6.png";